export enum OrderRefundEventType {
  Shipping = "shipping",
  LandedCost = "landed_cost",
}
